import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import styles from './ProductPage.module.css';
import MobiStyles from './ProductPageMobi.module.css';

import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import PlusMinusSelect from '../ForAllComponents/PlusMinusSelect';
import utilsRestMenus from '../Connections/_Utils/utilsRestMenus';
import { RestMenuContext } from '../Contexts/RestMenu_Context';
import MyFunctions from '../Functions/MyFunctions';
import { TheOrderContext } from '../Contexts/TheOrder_Context';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import PopUpClearComp from '../PopUps/PopUpClearComp';
import ProductOptionsSelect from './ProductOptionsSelect';
import { CurrentPContext } from '../Contexts/CurrentP_Context';

const ProductPage = (props) => {

    const navigate = useNavigate();
    const [restMenu, setRestMenu, getMenu] = useContext(RestMenuContext)
    const { theOrder, setTheOrder, addToTheOrder, updateTheOrd } = useContext(TheOrderContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [theProd, setTheProd] = useState({})
    const [theProdSection, setTheProdSection] = useState({})
    const [noProduct, setNoProduct] = useState(false)
    const [loading, setLoading] = useState(true);
    const [countVal, setCountVal] = useState(1);
    const [randomProducts, setRandomProducts] = useState([]);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : MobiStyles);
    const [thePopUp, setThePopUp] = useState("");

    const [prodIsInOrder, setProdIsInOrder] = useState(false);
    const { productId } = useParams();

    useEffect(() => {
        setCurrentStyle(!mobiOrNot ? styles : MobiStyles)
    }, [mobiOrNot]);

    useEffect(() => {
        getFromMenu(restMenu);
    }, []);


    useEffect(() => {
        getFromMenu(restMenu);
    }, [restMenu, productId, theOrder]);

    const getFromMenu = (restMenu) => {
        if (restMenu) {
            const foundItem = restMenu.buisMenu.flatMap((section) => {
                const product = section.Products.find((product) => product._id === productId);
                if (product) {
                    return { product, section };
                }
                return null;
            }).find((item) => item !== null);

            if (foundItem) {
                // let myProd = foundItem.product;
                // myProd = MyFunctions.fixProductPrice(myProd, theOrder); // עדכון מחיר אם צריך

                let tempHomP = { pageName: foundItem.section.DivName + " | " + foundItem.product.prodName || "נפוליאון מוצרים" }
                setCurrentPage({ ...tempHomP, pageTYp: "" });
                const orderItem = theOrder.items.find((item) => item._id === productId);

                setProdIsInOrder(orderItem);

                setTheProd(foundItem.product); // קביעת המוצר להצגה
                setTheProdSection({
                    sectionName: foundItem.section.DivName,
                    secondHead: foundItem.section.DivDescript,
                    sectionProducts: foundItem.section.Products,
                });

                setRandomProducts(MyFunctions.getRandomProductsToList(restMenu, 10, foundItem.product));
            } else {
                // אם לא נמצא מוצר מתאים
                setNoProduct(true);
            }

            setLoading(false);
        } else {
            getMenu();
        }
    }

    const goToMenu = () => {
        navigate(`/Mnu/0`);
    }
    // const goToSectionInMenu = (secId) => {
    //     navigate(`/Mnu/${secId}`);
    // }


    const addThisItem = (item, indx = -1) => {

        if (item.prodOptions && item.prodOptions.length > 0) {
            setThePopUp(
                <PopUpClearComp BtnTxt={"סגור"}
                    title={""}
                    noLineStart={true}
                    btnFStyle={"fatInBtn"}
                    fullPop={true}
                    closePop={() => setThePopUp()}
                    parentCLose={() => setThePopUp()}
                    theInsideComp={
                        <ProductOptionsSelect
                            saveIt={() => {
                                setProdIsInOrder(true);
                                setThePopUp();
                            }}
                            closePop={() => setThePopUp()}
                            indx={indx}
                            item={item}
                            options={item.prodOptions} />
                    } />
            )
        }
        else {
            updtOrAdd(item);
        }
    }

    const updtOrAdd = (item) => {
        let tempOrdIndx = theOrder.items.findIndex(ord => ord._id === item._id);
        if (tempOrdIndx !== -1) {
            theOrder.items[tempOrdIndx] = item;
            updateTheOrd(theOrder);
        }
        else {
            addToTheOrder(item);
        }
        setProdIsInOrder(true);
    }

    const updateCountVal = (newVal, orderItem) => {
        let tempOrdIndx = theOrder.items.findIndex((ord) => ord.innerIndx === orderItem.innerIndx);
        let tempOrd = { ...theOrder };
        if (tempOrdIndx !== -1) {
            tempOrd.items[tempOrdIndx].mount = newVal;
            updateTheOrd(tempOrd);
        }
    }

    const removeFromCart = (innerIndx) => {
        let tempOrd = { ...theOrder };
        let tempOrdIndx = theOrder.items.findIndex((ord) => ord.innerIndx === innerIndx);

        tempOrd.items.splice(tempOrdIndx, 1);
        updateTheOrd(tempOrd);
    }

    return (
        !loading &&
        <div className={`${currnetStyle.producPage} regularPoint`}>
            {!noProduct &&
                (!mobiOrNot) ?
                <div className={`${currnetStyle.productWrap} flexIt`}>
                    <div className={`${currnetStyle.imageItemBlock} flex-1`}>
                        <div className={currnetStyle.prodImageSpecSign}>
                        </div>
                        <div className={currnetStyle.prodImage}>
                            <img src={theProd.prodImageUrl !== "" ? ConnUrls.servMediasUrl + theProd.prodImageUrl : ConnUrls.servMediasUrl + restMenu.mnuItemMainImg}
                                alt={theProd.altTags || theProd.prodName || ""} />
                        </div>
                    </div>
                    <div className={`${currnetStyle.prodDetails} flex-2`}>
                        <div className={currnetStyle.heads}>
                            <div className={currnetStyle.headstop}>
                                <h1 className={currnetStyle.headsMain}>
                                    {parse(`${theProd.prodName}`)}
                                </h1>
                                <div className={`${currnetStyle.prodPricePlace} onLeft`}>
                                    <div className={`${currnetStyle.prodPrice} flexIt flex-Center`}>
                                        {theProd.prodPrice} ₪
                                    </div>

                                </div>
                            </div>
                            <div className={currnetStyle.headsSecond}>
                                {parse(`${theProd.prodRemarks}`)}
                            </div>
                        </div>
                        <div className={"seperatorDubleLine"}></div>
                        <div className={currnetStyle.prodInsideDetails}>
                            <div className={currnetStyle.prodInDetailsHead}>
                                {theProd.prodSmallText && parse(`${theProd.prodSmallText}`)}
                            </div>
                            <div className={currnetStyle.prodInDetailsDescription}>
                                {theProd.prodProducts && parse(`${theProd.prodProducts}`)}
                            </div>
                        </div>
                        <div className={currnetStyle.seperatorLine}></div>
                        <div className={`${currnetStyle.prodPriceAndAdd} flexIt`}>
                            <div className={`${currnetStyle.blkWrap} flex-1`}>
                                {prodIsInOrder && <div className={"inOrderP bold big fullRow"}>נמצא בהזמנה</div>}
                                {theOrder.items
                                    .filter(orderItem => orderItem._id === theProd._id)
                                    .map((orderItem, idx) => {
                                        let totIT = 0;
                                        return (
                                            <div key={idx} className={`${currnetStyle.grayLine} spaceTopBig flexIt`}>
                                                <div className={"bold big flex-1"}>
                                                    {orderItem.prodOptions?.map((optionGroup, index) => {
                                                        const selectedOptions = optionGroup.options.filter((opt) => opt.selected);
                                                        totIT += selectedOptions.reduce((total, opt) => {
                                                            const addToPrice = parseFloat(opt.addToPrice || 0);
                                                            const mount = opt.mount > 0 ? opt.mount : 1;
                                                            return total + addToPrice * mount;
                                                        }, 0);
                                                        return selectedOptions.length > 0 ? (
                                                            <div key={index}>
                                                                <span className={"fullRow small"}>{optionGroup.optionName}:</span>
                                                                <>
                                                                    {selectedOptions.map((selectedOpt, optIndex) => (
                                                                        <div key={optIndex}>
                                                                            <div className={"fullRow"}>
                                                                                <span className={"fullRow regular"}>{selectedOpt.servType}</span>
                                                                                {selectedOpt.mount > 1 ? <span className={"fullRow small"}>כמות: {selectedOpt.mount}</span> : ""}
                                                                                {selectedOpt.addToPrice > 0 ? <span className={"fullRow small"}>(+{selectedOpt.addToPrice * selectedOpt.mount})</span> : ""}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                    <div className={"fullRow regular"}>כמות: {orderItem.mount}</div>

                                                    <div className={"fullRow regular"}>מחיר: ₪{(theProd.prodPrice * orderItem.mount) + totIT}</div>
                                                </div>
                                                <div className={"flex-1"}>
                                                    <div className={currnetStyle.PlusMinusSelectWrap}>
                                                        <div className={"fullRow"}>
                                                            <div className={`${styles.removeFromCart} bold pointing onLeft spaceMargeRight_10`} onClick={() => removeFromCart(orderItem.innerIndx)}>
                                                                הסר
                                                            </div>
                                                            {theProd.prodOptions && theProd.prodOptions.length > 0 &&
                                                                <div className={`${styles.removeFromCart} bold pointing onLeft spaceMargeRight_10`}
                                                                    onClick={() => addThisItem(theProd, idx)}>
                                                                    שנה
                                                                </div>}
                                                        </div>
                                                        <PlusMinusSelect
                                                            css={currnetStyle.PlusMinusSelect}
                                                            plusBtnStyle={currnetStyle.plusBtn}
                                                            mountNumStyle={currnetStyle.mountNum}
                                                            minusBtnStyle={currnetStyle.minusBtn}
                                                            Mount={orderItem.mount || 1} // בדיקת סוג
                                                            minCount={1}
                                                            theVal={(newVal) => updateCountVal(newVal, orderItem)}
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>

                            <div className={`${currnetStyle.btnsWrap} flex-1`}>
                                <div className={"onLeft"}>
                                    {!prodIsInOrder ?
                                        <div className={`${currnetStyle.addToCartBtnwrap} `}>
                                            <div className={`${currnetStyle.addToCartBtn}
                                     ${currnetStyle.animate__pulseToIN} animate__animated animate__faster  pointing`}
                                                onClick={() => addThisItem(theProd)}>
                                                הוספה לסל
                                            </div>
                                        </div>
                                        :
                                        (theProd.prodOptions && theProd.prodOptions.length > 0) ?
                                            <div className={`${currnetStyle.addToCartBtnwrap}`} onClick={() => addThisItem(theProd, theOrder.items
                                                .filter(orderItem => orderItem._id === theProd._id).length)}>

                                                <div className={`${currnetStyle.addToCartBtn}
                                        ${currnetStyle.animate__pulseToIN} animate__animated animate__faster  pointing`}>
                                                    עוד אחד שונה
                                                </div>
                                            </div>
                                            : ""
                                    }

                                    <div className={`${currnetStyle.addToCartBtnwrap}`} onClick={() => goToMenu()}>
                                        <div className={`${currnetStyle.addToCartBtn} 
                                    ${currnetStyle.animate__pulseToIN} animate__animated animate__faster  pointing`}>
                                            לתפריט המלא
                                        </div>
                                    </div>
                                    <div className={`${currnetStyle.addToCartBtnwrap}`} onClick={() => navigate(`/shopCrt`)}>
                                        <div className={`${currnetStyle.addToCartBtn} 
                                    ${currnetStyle.animate__pulseToIN} animate__animated animate__faster  pointing`}>
                                            לסל הקניות
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <>
                    <div className={`${currnetStyle.imageItemBlock} flex-1`}>
                        <div className={currnetStyle.prodImageSpecSign}>
                        </div>
                        <div className={currnetStyle.prodImage}>
                            <img src={theProd.prodImageUrl !== "" ? ConnUrls.servMediasUrl + theProd.prodImageUrl : ConnUrls.servMediasUrl + restMenu.mnuItemMainImg}
                                alt={theProd.altTags || theProd.prodName || ""} />
                        </div>
                    </div>
                    <div className={`${currnetStyle.productWrap} flexIt`}>
                        <div className={`${currnetStyle.prodDetails} flex-2`}>
                            <div className={currnetStyle.heads}>
                                <h1 className={currnetStyle.headsMain}>
                                    {parse(`${theProd.prodName}`)}
                                </h1>
                                <div className={`${currnetStyle.prodPrice}`}>
                                    {theProd.prodPrice} ₪
                                </div>
                                <div className={currnetStyle.headsSecond}>
                                    {parse(`${theProd.prodRemarks}`)}
                                </div>
                            </div>
                            <div className={"seperatorDubleLine"}></div>
                            <div className={currnetStyle.prodInsideDetails}>
                                <div className={currnetStyle.prodInDetailsHead}>
                                    {theProd.prodSmallText && parse(`${theProd.prodSmallText}`)}
                                </div>
                                <div className={currnetStyle.prodInDetailsDescription}>
                                    {theProd.prodProducts && parse(`${theProd.prodProducts}`)}
                                </div>
                            </div>

                            <div className={`${currnetStyle.blkWrap} flex-1`}>
                                {!prodIsInOrder ?
                                    <div className={`${currnetStyle.addToCartBtnwrap} `}>
                                        <div className={`${currnetStyle.addToCartBtn}
                                 ${currnetStyle.animate__pulseToIN} animate__animated animate__faster onRight pointing`}
                                            onClick={() => addThisItem(theProd)}>
                                            הוספה לסל
                                        </div>
                                    </div>
                                    :
                                    <div className={`${currnetStyle.addToCartBtnwrap}`} onClick={() => addThisItem(theProd, theOrder.items
                                        .filter(orderItem => orderItem._id === theProd._id).length)}>

                                        <div className={`${currnetStyle.addToCartBtn}
                                    ${currnetStyle.animate__pulseToIN} animate__animated animate__faster onRight  pointing`}>
                                            עוד אחד שונה
                                        </div>
                                    </div>
                                }

                                <div className={`${currnetStyle.addToCartBtnwrap}`} onClick={() => goToMenu()}>
                                    <div className={`${currnetStyle.addToCartBtn} 
                                    ${currnetStyle.animate__pulseToIN} animate__animated animate__faster onRight  pointing`}>
                                        לתפריט המלא
                                    </div>
                                </div>
                                <div className={`${currnetStyle.addToCartBtnwrap}`} onClick={() => navigate(`/shopCrt`)}>
                                    <div className={`${currnetStyle.addToCartBtn} 
                                    ${currnetStyle.animate__pulseToIN} animate__animated animate__faster onRight pointing`}>
                                        לסל הקניות
                                    </div>
                                </div>
                            </div>
                            {prodIsInOrder && (
                                <div className={"fullRow spaceTopBig"}>
                                    {prodIsInOrder && <div className={"inOrderP bold biger fullRow"}>נמצא בהזמנה</div>}

                                    {theOrder.items
                                        .filter(orderItem => orderItem._id === theProd._id)
                                        .map((orderItem, idx) => {
                                            let totIT = 0;
                                            return (
                                                <div key={idx} className={`${currnetStyle.grayLine} spaceTopBig flexIt`}>
                                                    {/* <div className={"fullRow"}>
                                                        <div className={"centerthisdiv"}>
                                                            <div className={`${styles.removeFromCart} bold pointing onLeft spaceMargeRight_10`} onClick={() => removeFromCart(orderItem.innerIndx)}>
                                                                הסר
                                                            </div>
                                                            {theProd.prodOptions && theProd.prodOptions.length > 0 &&
                                                                <div className={`${styles.removeFromCart} 
                                                            bold pointing onLeft spaceMargeRight_10`} onClick={() => addThisItem(theProd, idx)}>
                                                                    שנה
                                                                </div>}
                                                        </div>
                                                    </div> */}
                                                    <div className={"blueFrame flex-1"}>
                                                        <div className={""}>
                                                            <div className={currnetStyle.PlusMinusSelectWrap}>
                                                                <div className={"fullRow"}>
                                                                    <div className={`${styles.removeFromCart} bold pointing onLeft spaceMargeRight_10`} onClick={() => removeFromCart(orderItem.innerIndx)}>
                                                                        הסר
                                                                    </div>
                                                                    {theProd.prodOptions && theProd.prodOptions.length > 0 &&
                                                                        <div className={`${styles.removeFromCart} bold pointing onLeft spaceMargeRight_10`}
                                                                            onClick={() => addThisItem(theProd, idx)}>
                                                                            שנה
                                                                        </div>}
                                                                </div>
                                                                <PlusMinusSelect
                                                                    css={currnetStyle.PlusMinusSelect}
                                                                    plusBtnStyle={currnetStyle.plusBtn}
                                                                    mountNumStyle={currnetStyle.mountNum}
                                                                    minusBtnStyle={currnetStyle.minusBtn}
                                                                    Mount={orderItem.mount || 1} // בדיקת סוג
                                                                    minCount={1}
                                                                    theVal={(newVal) => updateCountVal(newVal, orderItem)}
                                                                />
                                                            </div>

                                                        </div>


                                                        <div className={"bold big onRight"}>
                                                            {orderItem.prodOptions?.map((optionGroup, index) => {
                                                                const selectedOptions = optionGroup.options.filter((opt) => opt.selected);
                                                                totIT += selectedOptions.reduce((total, opt) => {
                                                                    const addToPrice = parseFloat(opt.addToPrice || 0);
                                                                    const mount = opt.mount > 0 ? opt.mount : 1;
                                                                    return total + addToPrice * mount;
                                                                }, 0);
                                                                return selectedOptions.length > 0 ? (
                                                                    <div key={index}>
                                                                        <span className={"fullRow small"}>{optionGroup.optionName}:</span>
                                                                        <div>
                                                                            {selectedOptions.map((selectedOpt, optIndex) => (
                                                                                <div key={optIndex}>
                                                                                    <div className={"fullRow"}>
                                                                                        <span className={"fullRow regular"}> {selectedOpt.servType}</span>
                                                                                        {selectedOpt.mount > 1 ? <span className={"fullRow small"}>כמות: {selectedOpt.mount}</span> : ""}
                                                                                        {selectedOpt.addToPrice > 0 ? <span className={"fullRow small"}>(+{selectedOpt.addToPrice * selectedOpt.mount})</span> : ""}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ) : null;
                                                            })}
                                                            <div className={"fullRow regular"}>כמות: {orderItem.mount}</div>
                                                            <span className={"fullRow regular"}>
                                                                מחיר: {(theProd.prodPrice + totIT) * orderItem.mount} ₪
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className={"spacePaddingTop_5 spacePaddingBottom_5"}></div>
                                                </div>
                                            );
                                        })}
                                </div>
                            )}

                        </div>
                    </div>
                </>
            }
            <SwiperSection
                theSectionHeader={{
                    mainHead: "עוד " + theProdSection.sectionName,
                    secondHead: theProdSection.secondHead
                }}
                itemsOfSection={theProdSection.sectionProducts?.filter(prod => prod._id !== theProd._id)}
                mnuItemMainImg={restMenu.mnuItemMainImg}
            />
            <SwiperSection
                theSectionHeader={{
                    mainHead: "עוד מוצרים",
                    secondHead: ""
                }}
                itemsOfSection={randomProducts}
                mnuItemMainImg={restMenu.mnuItemMainImg}
            />
            {thePopUp}
        </div>
    );
}

export default ProductPage;
